import React, { useState } from "react";
import { Mail, MapPin, Phone, Send, Instagram, Facebook, Linkedin } from "lucide-react";
import { FOOTER } from "../mock";
import { useToast } from "../hooks/use-toast";

const Footer = () => {
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const onSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({
      title: "Welcome to NutExpert!",
      description: `We'll send the best nut stories to ${email}.`,
    });
    setEmail("");
  };

  return (
    <footer id="contact" className="bg-stone-900 text-stone-300">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="text-2xl text-white">
            Nut<span className="font-bold">Expert</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-stone-400 max-w-sm">
            Specialist in almonds, walnuts, cashews, pistachios and every nut in between. Sourced
            with care, roasted slowly, delivered fresh.
          </p>
          <form onSubmit={onSubscribe} className="mt-6 flex items-stretch max-w-sm">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="flex-1 bg-stone-800 border border-stone-700 px-4 py-2.5 text-sm text-white placeholder:text-stone-500 focus:outline-none focus:border-[#c8232c]"
            />
            <button type="submit" className="bg-[#c8232c] hover:bg-[#a81b22] text-white px-4 flex items-center justify-center">
              <Send size={16} />
            </button>
          </form>
          <div className="flex items-center gap-4 mt-6">
            <a href="#0" className="text-stone-400 hover:text-white" aria-label="Instagram">
              <Instagram size={0} />
            </a>
            <a href="#0" className="text-stone-400 hover:text-white" aria-label="Facebook">
              <Facebook size={0} />
            </a>
            <a href="#0" className="text-stone-400 hover:text-white" aria-label="LinkedIn">
              <Linkedin size={0} />
            </a>
          </div>
        </div>

        {FOOTER.columns.map((col) => (
          <div key={col.title}>
            <div className="text-white font-medium tracking-wider uppercase text-sm">{col.title}</div>
            <ul className="mt-4 space-y-2.5">
              {col.items.map((it) => (
                <li key={it}>
                  <a href="#0" className="text-sm text-stone-400 hover:text-white">{it}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <div className="text-white font-medium tracking-wider uppercase text-sm">Contact</div>
          <ul className="mt-4 space-y-3 text-sm text-stone-400">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" />{FOOTER.contact.address}</li>
            <p>Mon. — Fri.      9:00 AM — 6:00 PM</p>
            <li className="flex items-center gap-2"><Mail size={16} />{FOOTER.contact.email}</li>
            <iframe loading="lazy"
					src="https://maps.google.com/maps?q=6%20Rue%20de%20la%20Garenne%2C%2010350%20Marigny-le-Ch%C3%A2tel&#038;t=m&#038;z=7&#038;output=embed&#038;iwloc=near"
					title="6 Rue de la Garenne, 10350 Marigny-le-Châtel"
					aria-label="6 Rue de la Garenne, 10350 Marigny-le-Châtel"
			></iframe>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800 py-5 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} NutExpert. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
